import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ActivateStripeCardPaymentWrapper = styled.button`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  justify-content: space-between;
  width: 100%;
  padding: ${Spacing.S12} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  text-align: left;
  cursor: pointer;
`

export const StripeLogo = styled.div`
  display: flex;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
`
